import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';

const CallStatusFilter = (props) => {

    const [callStatuses, setCallStatuses] = useState([]); 
    const [checkedElements, setCheckedElements] = useState([]);
    //const [abandonment, setAbandonment] = useState(false);

    const handleCheck = (event) => {
        let updatedList = [...checkedElements];
        if (event.target.checked) {
          updatedList = [...checkedElements, event.target.value];
        } else {
          updatedList.splice(checkedElements.indexOf(event.target.value), 1);
        }
        setCheckedElements(updatedList);
        props.setCallStatusFilter(updatedList);
    };

    // const handleAbandonment = (event) => {
    //     let includeAbandonments=event.target.checked;
    //     props.setIncludeAbandonmentsFilter(includeAbandonments.toString());
    //     setAbandonment(includeAbandonments); //just for highlite
    // }

    useEffect(() => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 

        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/asteriskCallStatus`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setCallStatuses(response.data)
        })
        .catch(function (error) {
            console.log("Error:", error.message);
        });
    }, []);

    return (
        <div className="callStatusFilter">  
            <h5 className='sectionTitle'>FILTRO ESTADOS DE LLAMADA</h5>
            <div className="checkboxesWrapper">
                {callStatuses.map((item, index) => (
                    <label key={index} className={checkedElements.includes(item.asteriskDesc)?'selected':''}>
                        <input value={item.asteriskDesc} type="checkbox" onChange={handleCheck}/>
                        {item.translation}
                    </label>
                ))}

                {/* <label className={abandonment?'selected':''}>
                    <input name="includeAbandonments" type="checkbox" onChange={handleAbandonment}/>
                    Incluye abandonos
                </label> */}
            </div>
        </div>
    );
    
}

export default CallStatusFilter;
